var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49996 4.83333H4.49996M9.49996 8.16667H4.49996M9.49996 11.5H6.16663M1.16663 1.5H12.8333V16.5L11.9733 15.7633C11.6712 15.5045 11.2865 15.3622 10.8887 15.3622C10.4909 15.3622 10.1062 15.5045 9.80413 15.7633L8.94413 16.5L8.08496 15.7633C7.78284 15.5042 7.39797 15.3618 6.99996 15.3618C6.60195 15.3618 6.21708 15.5042 5.91496 15.7633L5.05579 16.5L4.19579 15.7633C3.89373 15.5045 3.50903 15.3622 3.11121 15.3622C2.71339 15.3622 2.32869 15.5045 2.02663 15.7633L1.16663 16.5V1.5Z",
    stroke: "#FF7C02",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.709ea50164cc61cce4ed2aaa7ee05be9.svg";
export { ForwardRef as ReactComponent };